import React, { memo, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import TypeWriter from './TypeWriter';
import {
  aigcReplysWritingEnd,
  aigcReplyWritingStop,
  aigcReplyIsBusing,
  aigcGetReplys,
  aigcReplysZanDao,
} from '../../../../actions/aigc';
import { logging } from '../../../../actions/log';

const selectIsBusing = createSelector(
  state => state.aigc,
  aigc => aigc.isBusing,
);

export default memo(
  ({
    styles,
    answerIndex,
    answerItem = {},
    answerIndexShow,
    h5IDAll,
    start = () => {},
    showOperate = false,
    reAnswerShow,
    reAnswerback = () => {},
  }) => {
    const dispatch = useDispatch();
    const isBusing = useSelector(selectIsBusing);
    const [stopTag, setStopTag] = useState(false);
    const [reNum, setReNum] = useState(1);
    const likeNode = useRef(null);
    const dislikeNode = useRef(null);

    useEffect(() => {
      if (isBusing === 4) {
        setStopTag(true);
      }
    }, [isBusing]);

    const answerback = () => {
      if (!stopTag) {
        dispatch(aigcReplysWritingEnd({ h5IDAll, h5ID: answerItem?.h5ID }));
        dispatch(aigcReplyIsBusing({ isBusing: 5 }));
      }
    };

    const handlePauseText = data => {
      dispatch(aigcReplyWritingStop({ ...h5IDAll, ...data }));
      dispatch(aigcReplyIsBusing({ isBusing: 4 }));
    };

    const handleReAnswer = () => {
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Aigc_Recall',
          label: '',
          param2: {
            search_word: userText,
          },
          param3: answerItem?.bizInfo,
        }),
      );

      dispatch(
        aigcGetReplys({
          isReAnswer: true,
          reAnswer: {
            h5IDAll,
            h5ID: answerItem?.h5ID,
          },
        }),
      );
      reAnswerback();
    };

    return (
      <>
        {answerItem?.writing === 2 && (
          <TypeWriter
            node={` ${
              answerIndexShow ? `<span class=${styles.chat_index}>回答${answerIndex}</span> ` : ``
            }<span class='${styles.chat}' id='chat_tip'>${answerItem?.commandMsg?.tip}</span>`}
            answerCallback={answerback}
            startCallback={() => {
              start();
            }}
            controlStop={stopTag}
            stopCallback={data => handlePauseText(data)}
          />
        )}
        {answerItem?.writing === 3 && (
          <>
            {answerIndexShow && <span className={styles.chat_index}>回答{answerIndex}</span>}{' '}
            <span className={styles.chat}>{answerItem?.commandMsg?.tip}</span>
            {reAnswerShow && showOperate && answerItem.canFresh && (
              <div className="info_operate">
                <div className="re_answer" onClick={handleReAnswer}>
                  <i className="iconfont icon-ai_chongxinhuida" /> 重新回答
                </div>
              </div>
            )}
          </>
        )}
        {answerItem?.writing === 4 && (
          <>
            {answerIndexShow && <span className={styles.chat_index}>回答{answerIndex}</span>}{' '}
            <span className={styles.chat}>{answerItem?.commandMsg?.tip}</span>
            {reAnswerShow && showOperate && answerItem.canFresh && (
              <div className="info_operate">
                <div className="re_answer" onClick={handleReAnswer}>
                  <i className="iconfont icon-ai_chongxinhuida" /> 重新回答
                </div>
              </div>
            )}
          </>
        )}
      </>
    );
  },
);
